module.exports = __webpack_public_path__ + "img/happytable_product2.797351b0.jpg";